<template>
  <div class="header">
    <nav class="navbar">
      <div class="icons" style="display: none">
        <a
          class="icons_img"
          title="起亚汽车官网"
          href="/"
          code-ga="event, C02_everypage, 全站导航点击, C02A06L05_everypage_全站导航点击_起亚logo"
          code-stm="event, 头部导航栏, 起亚logo"
        >
          <i class="icon icon-logo-kn"></i>
        </a>
      </div>
      <div class="navbar-group">
        <ul class="item">
          <li class="important totalCars">
            <a
              class="nav_0"
              href="javascript:void(0);"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L05_everypage_全站导航点击_全系车型"
              code-stm="event, 头部导航栏, 全系车型"
              @click="showTotalCars"
              >全系车型 <i class="line"></i
            ></a>
            <div class="vehicle-list-container">
              <div class="inner-navbar-bg" data-reserve="true">
                <div class="inner-navbar">
                  <div class="container">
                    <ul class="tab-box pull-left">
                      <li data-id="#block0">新车上市(1)</li>
                      <li data-id="#block1">MPV/SUV(5)</li>
                      <li data-id="#block2">轿车(3)</li>
                      <li data-id="#block3" data-type="newenergy">
                        新能源车(1)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="vehicle-list" v-cloak>
                <div class="container">
                  <h1>新车上市</h1>
                  <div class="list-group" id="block0">
                    <ul class="ul">
                      <li>
                        <a class="pic" href="/vehicles/thenewk3/" code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}" code-stm="event, {PageUrl}, 车型图片_{id}">
                          <img src="/assets/~/media/images/vehicle/thenewk3/45chetu/yellow.png">
                          <img class="hover-img" src="/assets/~/media/images/vehicle/thenewk3/g1/yellow.png">
                        </a>
                        <div class="name"><a href="/vehicles/sportage/">新K3</a></div>
                        <div class="price"><span>¥</span><strong>112,900</strong> <small>起</small></div>
                        <div class="link-box">
                          <a href="/vehicles/thenewk3/specs/109/" code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}" code-stm="event, {PageUrl}, 配置_{id}">配置<i class="icon icon-right"></i></a>
                          <a href="/test-drive/?car_id=25" code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}" code-stm="event, {PageUrl}, 预约试驾_{id}">预约试驾<i class="icon icon-right"></i></a>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <h1>MPV/SUV</h1>
                  <div class="list-group" id="block1">
                     <ul class="ul">
                       <li>
                         <a class="pic" href="/vehicles/sportage/" code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}" code-stm="event, {PageUrl}, 车型图片_{id}">
                           <img src="/assets/~/media/images/vehicle/sportage/positive-side-45.jpg">
                           <img class="hover-img" src="/assets/~/media/images/vehicle/sportage/g1/g1-1.png">
                         </a>
                         <div class="name"><a href="/vehicles/sportage/">狮铂拓界</a></div>
                         <div class="price"><span>¥</span><strong>179,800</strong> <small>起</small></div>
                         <div class="link-box">
                           <a href="/vehicles/sportage/specs/85/" code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}" code-stm="event, {PageUrl}, 配置_{id}">配置<i class="icon icon-right"></i></a>
                           <a href="/test-drive/?car_id=22" code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}" code-stm="event, {PageUrl}, 预约试驾_{id}">预约试驾<i class="icon icon-right"></i></a>
                         </div>
                       </li>
                     </ul>
                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/carnival/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/carnival/positive-side/oblique.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/carnival/positive-side/body/blue.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/carnival/">嘉华</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>289,900</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/carnival/specs/81/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=20"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>
                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/zhipao-ace/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/sportage-ace/basic/1.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/sportage-ace/basic/blue.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/zhipao-ace/">智跑</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>139,800</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/zhipao-ace/specs/79/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=19"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>
                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/allnewkx3/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/allnewkx3/20210526/kx3.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/allnewkx3/20210526/side/1.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/allnewkx3/">傲跑</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>108,800</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/allnewkx3/specs/1/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=2"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>

                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/kx1/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/kx1/20210601/kx1.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/kx1/car_slide/20210604/01.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/kx1/">奕跑</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>69,800</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/kx1/specs/11/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=3"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <h1>轿车</h1>
                  <div class="list-group" id="block2">
                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/allnewk5/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/allnewk5/positive-side/1207.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/allnewk5/car_slide/20210526/allnewk5_05.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/allnewk5/">K5</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>139,800</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/allnewk5/specs/60/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=7"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>
                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/forte/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/forte/forte45.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/forte/car_slide/forte_no_1.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/forte/">福瑞迪</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>80,800</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/forte/specs/46/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=11"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>
                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/pegas/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/pegas/20210607/pegas.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/pegas/car_slide/20210615/red.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/pegas/">焕驰</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>66,900</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/pegas/specs/48/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=12"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <h1>新能源车</h1>
                  <div class="list-group" id="block3">
                    <ul class="ul">
                      <li>
                        <a
                          class="pic"
                          href="/vehicles/k3ev/"
                          code-ga="event, C13_车型列表页, 车型图片点击, C13A01L{id}_车型列表页_车型图片点击_{名称}"
                          code-stm="event, {PageUrl}, 车型图片_{id}"
                        >
                          <img
                            src="/assets/~/media/images/vehicle/k3ev/202105/k3ev.png"
                          />
                          <img
                            class="hover-img"
                            src="/assets/~/media/images/vehicle/k3ev/yanse/20210531/white.png"
                          />
                        </a>
                        <div class="name">
                          <a href="/vehicles/k3ev/">K3 EV</a>
                        </div>
                        <div class="price">
                          <span>¥</span><strong>229,800</strong>
                          <small>起</small>
                        </div>
                        <div class="link-box">
                          <a
                            href="/vehicles/k3ev/specs/66/"
                            code-ga="event, C13_车型列表页, 配置点击, C13A02L{id}_车型列表页_配置点击_{名称}"
                            code-stm="event, {PageUrl}, 配置_{id}"
                            >配置<i class="icon icon-right"></i
                          ></a>
                          <a
                            href="/test-drive/?car_id=18"
                            code-ga="event, C13_车型列表页, 预约试驾点击, C13A03L{id}_车型列表页_预约试驾点击_{名称}"
                            code-stm="event, {PageUrl}, 预约试驾_{id}"
                            >预约试驾<i class="icon icon-right"></i
                          ></a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <i class="icon icon-close1 chacha" @click="close"></i>
            </div>
          </li>
          <!-- <li class="important">
            <a
              class="nav_0"
              href="/shop-made-easy/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L06_everypage_全站导航点击_购车指南"
              code-stm="event, 头部导航栏, 购车指南"
              >购车指南 <i class="line"></i
            ></a>
          </li> -->
          <li>
            <a
              class="nav_0"
              href="/promotions/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L07_everypage_全站导航点击_市场活动"
              code-stm="event, 头部导航栏, 市场活动"
              >市场活动 <i class="line"></i
            ></a>
          </li>

          <li>
            <a
              class="nav_0"
              href="/owners/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L08_everypage_全站导航点击_车主服务"
              code-stm="event, 头部导航栏, 车主服务"
              >车主服务 <i class="line"></i
            ></a>
          </li>
          <li>
            <a
              class="nav_0"
              href="/promotions/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L08_everypage_全站导航点击_精彩活动"
              code-stm="event, 头部导航栏, 精彩活动"
              >精彩活动<i class="line"></i
            ></a>
          </li>
          <div class="icon_img">
            <a
              class="logo logo-left"
              title="起亚汽车官网"
              href="/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L05_everypage_全站导航点击_起亚logo"
              code-stm="event, 头部导航栏, 起亚logo"
            >
              <i class="icon icon-logo-kn"></i>
            </a>
          </div>
          <li>
            <a
              class="nav_0"
              href="/brand/brand-identity/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L08_everypage_全站导航点击_品牌理念"
              code-stm="event, 头部导航栏, 品牌理念"
              >品牌理念 <i class="line"></i
            ></a>
          </li>
          <li>
            <a
              class="nav_0"
              href="/test-drive/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L09_everypage_全站导航点击_预约试驾"
              code-stm="event, 头部导航栏, 预约试驾"
              >预约试驾 <i class="line"></i
            ></a>
          </li>
          <li>
            <a
              class="nav_0"
              href="/dealer/"
              code-ga="event, C02_everypage, 全站导航点击, C02A06L10_everypage_全站导航点击_经销商查询"
              code-stm="event, 头部导航栏, 经销商查询"
              >经销商查询 <i class="line"></i
            ></a>
          </li>
          <li class="search">
            <form>
              <input type="text" placeholder="搜索" />
              <button type="submit" class="search-submit">
                <i class="icon icon-search"></i>
              </button>
            </form>
          </li>
        </ul>
      </div>

      <div class="phone-btn">
        <div class="menu"></div>
      </div>
    </nav>
  </div>
</template>

<script>
import $ from "jquery";
// import "../utils/navbar";
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip: false,
      carStyleList: [],
    };
  },
  // created: function () {
  //   this.$axios.get('/assets/~/media/files/genfiles/csm.js').then((res) => {
  //     console.log("123",res);
  //     this.carStyleList = res.data.seriesList;
  //   })
  // },
  mounted: function () {
    this.navBar();
    this.tabChange(0)
    if (getUrlKey("minip")) {
      this.minip = true;
    }
  },
  methods: {
    // 关于导航栏操作
    navBar() {
      $(".navbar").css({
        "background-color": "rgba(0,0,0,0.1)",
      });
      $('.navbar').mouseleave(function () {
        $(this).removeClass('hover')
        $('.navbar-group .item>li .nav_0').css('color', '#fff')
        $('.navbar-group .item>li button i').css('color', '#fff')
        $('.navbar-group .item .icon_img .logo i').css('color', '#fff')
      })
      $('.navbar').mouseenter(function () {
        $(this).addClass('hover')
        $('.navbar-group .item>li .nav_0').css('color', '#000')
        $('.navbar-group .item>li button i').css('color', '#000')
        $('.navbar-group .item .icon_img .logo i').css('color', '#000')
      })
      if ($(".navbar").length == 0) return;
      const _this = this;
      if (this.isPortrait) {
        // if (navigator.userAgent.match(/mobile/i)) {
        $(
          "<img src='https://img.kia.cn/content/images/20220819_navbar_icon/menu.png'>"
        ).prependTo(".phone-btn .menu");
        $(
          "<div class='search_icon'><img src='https://img.kia.cn/content/images/20220819_navbar_icon/search.png'></div>"
        ).prependTo(".phone-btn");
        // $("<div class='search_input'><input type='text' placeholder='搜索'/><img src='https://img.kia.cn/content/images/20220819_navbar_icon/search_black.png'></div>").prependTo('.navbar')

        // if (window.location.pathname == "/") {
        $(".phone-btn .menu").css({
          filter: "brightness(100%)",
        }),
          $(".phone-btn .search_icon").css({
            filter: "brightness(100%)",
          });
        // }

        //点击搜索框
        $(".phone-btn .search_icon").click(function () {
          console.log(222);
          $(".navbar").addClass("hover");
          $(".phone-btn .search_icon").hide();
          // if (window.location.pathname == "/") {
          //   $(".phone-btn .menu").hide();
          // }
          $(
            "<div class='search_input'><form><input type='text' placeholder='搜索'/><img src='https://img.kia.cn/content/images/20220819_navbar_icon/search_black.png'></form></div>"
          ).prependTo(".navbar");
          $(".search_input input").focus();
          $(
            "<div class='close_icons'><img src='https://img.kia.cn/content/images/20220819_navbar_icon/close_black.png'></div>"
          ).prependTo(".navbar");
          $(".icons_img i").css({
            color: "#000",
          });
          //关闭按钮
          $(".navbar .close_icons img").click(function () {
            $(".navbar").removeClass("hover");
            console.log(111);
            $(".search_input").remove();
            $(".close_icon").remove();
            $(".search_icon").show();
            // if (window.location.pathname == "/") {
            //   $(".icons_img i").css({
            //     color: "#fff",
            //   });
            // }
            $(".phone-btn .menu").show();
            $(".navbar .close_icons").remove();
          });
        });
      } else {
        $(".menu .phone-btn").remove();
        $(".phone-btn .search_icon").remove();
      }
      // 导航栏逻辑操作
      (function () {
        // 首页和车型页 导航栏透明效果
        if ($(".home-page").length > 0 || $(".vehicle-page").length > 0) {
          function scrollInit() {
            const winTop = $(window).scrollTop();
            // 首页和车型页透明导航栏
            if (winTop > $(".navbar").height()) {
              // $('.navbar').addClass('active')
            } else {
              // $('.navbar').removeClass('active')
            }
          }

          // 初始化
          setTimeout(function () {
            scrollInit();
          }, 100);
          $(window).scroll(function () {
            scrollInit();
          });

          // pc端使用移入的方式
          // $(".navbar").hover(
          //   function () {
          //     if (!_this.Is.Pc()) return;
          //     // $('.navbar').addClass('active')
          //   },
          //   function () {
          //     if (!_this.Is.Pc()) return;
          //     if ($(window).scrollTop() <= $(".navbar").height()) {
          //       // $('.navbar').removeClass('active')
          //     }
          //   }
          // );
        }
        // 其他页面显示普通导航栏
        else {
          // console.log('aaa');
          // $('.navbar').addClass('active')
        }
      })();

      // 手机展开导航栏
      $(".navbar .phone-btn .menu").click(function () {
        $("<div class='hidebg'></div").insertAfter(".phone-btn");
        const Navbar = $(".navbar");
        // 显示下拉
        if (!Navbar.hasClass("open")) {
          $(".navbar .phone-btn .menu").hide();
          $(".navbar .icons_img i").css({
            color: "#fff",
          });
          $(
            '<div class="left-logo"><a class="icons_img" title="起亚汽车官网" href="/" code-ga="event, C02_everypage, 全站导航点击, C02A06L05_everypage_全站导航点击_起亚logo"><i class="icon icon-logo-kn"></i></a></div>'
          ).prependTo(".navbar-group");
          $(".navbar .search_icon").hide();
          $(
            "<div class='close_icon'><img src='https://img.kia.cn/content/images/20220819_navbar_icon/close_black.png'></div>"
          ).prependTo(".navbar-group");
          $(".navbar .navbar-group .item .search").remove();
          Navbar.addClass("open");
          $(".navbar").find(".navbar-group").slideDown(300);
          $(".navbar .close_icons").remove();
          $(".navbar .navbar-group .item")
            .find("li:not(:first-child)")
            .addClass("line");
          $(".navbar .navbar-group .item").find("li:first-child").css({
            "border-top": "2px solid #cdd0d2",
          });
        }
        // 关闭下拉
        $(".navbar .close_icon").click(function () {
          console.log(333);
          Navbar.removeClass("open");
          $(".hidebg").remove();
          // if (window.location.pathname == "/") {
          //   $(".icons_img i").css({
          //     color: "#fff",
          //   });
          // } else {
          $(".icons_img i").css({
            color: "#000",
          });
          // }
          $(".navbar .close_icon").remove();
          Navbar.removeClass("hover");
          $(".navbar").find(".navbar-group").hide().removeAttr("style");
          $(".navbar .phone-btn .menu").show();
          $(".navbar .search_icon").show();
          $(".navbar-group .left-logo").remove();
        });
      });

      // 手机端触摸除了自己之外的地方就移除展开导航栏状态
      $(document).bind("touchstart", function (e) {
        const Navbar = $(".navbar");
        if (
          $(e.target).closest(".navbar-group").length <= 0 &&
          $(e.target).closest(".phone-btn").length <= 0 &&
          Navbar.hasClass("open")
        ) {
          Navbar.removeClass("open");
          Navbar.removeClass("hover");
          //移除背景遮罩
          $(".hidebg").remove();
          //移除dakai样式
          $(".icons").removeClass("dakai");
          $(".phone-btn .search_icon").show();
          $(".navbar .search_input").remove();
          //logo图标为白色
          $(".icons_img i").css({
            color: "#fff",
          });

          $(".phone-btn .menu").css({
            display: "block",
          });
          //移除关闭按钮
          $(".close_icon").remove();
          $(".navbar").find(".navbar-group").hide().removeAttr("style");
        }
      });

      // 搜索框操作 pc端
      $(".navbar .search-submit").click(function () {
        const search = $(".navbar .search");
        if (!search.hasClass("open")) {
          setTimeout(function () {
            search.addClass("open");
          }, 10);
          $(".navbar .search input").focus();
        }
      });

      // 移除open状态
      $(".navbar .search input").blur(function () {
        const search = $(".navbar .search");
        if (!$(this).val()) {
          search.removeClass("open");
        }
      });

      // 搜索
      $(".navbar .search form").submit(function () {
        if (
          $(".navbar .search input").val() &&
          $(".navbar .search").hasClass("open")
        ) {
          let uri = "/home/search.html?key=";
          location.href = uri + $(".navbar .search input").val();
        }
      });
      //使用on监听点击事件更全面，解决点击事件不生效问题
      $(document).on("click", ".search_input form img", function () {
        console.log(555);
        if ($(".navbar .search_input input").val()) {
          let uri = "/home/search.html?key=";
          location.href = uri + $(".navbar .search_input input").val();
        }
      });

      // 隐私条款cookie
      (function () {
        const Id = ".privacy-box";
        if ($(Id).length > 0) {
          if (!$.cookie("Privacy_token")) {
            $(Id).show();
          }
          $(Id)
            .find(".btn")
            .click(function () {
              $.cookie("Privacy_token", true, { expires: 7 });
              $(Id).hide();
            });
        }
      })();
    },
    // 栏目切换
    tabChange(val) {
      // 滚动页面到指定位置
      console.log("44444444");
      function toScrollElement(isAni, ele, hTop) {
        $(".vehicle-list-container").animate(
          { scrollTop: $(ele).offset().top + (hTop ? hTop : 0) },
          isAni ? 300 : 0
        );
      }
      function setTab(index, first) {
        $(".tab-box li")
          .eq(index)
          .addClass("strong")
          .siblings()
          .removeClass("strong");
        console.log(111, index, first);
        if (!first) {
          toScrollElement("true", "h1:eq(" + index + ")", -60);
        }
      }

      $(".tab-box li").click(function () {
        const index = $(this).index();
        setTab(index);
      });

      $(document).on("click", ".list-group [data-type]", function () {
        const type = $(this).data("type");
        $('.tab-box li[data-type="' + type + '"]').click();
      });

      // // 监听滚动
      // setTimeout(function () {
      //   $(".tab-box li").each(function () {
      //     const block = $(this).data("id"),
      //       positionTop = $(block).offset().top - $(window).height() / 2;
      //     $(block).JQscrollspy({
      //       min: positionTop,
      //       max: positionTop + $(block).height(),
      //       onEnter: function (element) {
      //         const index = $(element).attr("id").replace("block", "");
      //         setTab(index, true);
      //       },
      //     });
      //   });
      // }, 10);
    },

    //鼠标放上去显示全部车型
    showTotalCars() {
      this.$emit("forbid");
      $(".vehicle-list-container").addClass("vehicle-list-hover");
      $(".navbar").css({
        "background-color": "#fff",
      });
    },
    close() {
      this.$emit("open");
      $(".vehicle-list-container").removeClass("vehicle-list-hover");
      $(".navbar").css({
        "background-color": "rgba(0,0,0,0.1)",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar .navbar-group .item>li .nav_0, .navbar .logo,.navbar .navbar-group .search button{
  color: #fff;
}
.header {
  .navbar .navbar-group {
    z-index: 3;
  }
  @media (max-width: 767px){
    .navbar{
      position: absolute!important;
    }
    .navbar .icons .icons_img{
      color: #fff;
    }
  }
}
h1 {
  font-size: 4.28rem;
  padding: 36px 0 24px;
  font-weight: 700;
}
.chacha {
  color: #000 !important;
}
.vehicle-list-container {
  z-index: 100;
}
.vehicle-list-container {
  display: block;
  position: fixed;
  left: 0;
  opacity: 0;
  pointer-events: none;
  top: 78px;
  -webkit-transform: translate(0, -100%);
  -ms-transform: translate(0, -100%);
  transform: translate(0, -100%);
  transition: opacity 0.2s linear, -webkit-transform 0.4s ease-out;
  transition: transform 0.4s ease-out, opacity 0.2s linear;
  transition: transform 0.4s ease-out, opacity 0.2s linear,
    -webkit-transform 0.4s ease-out;
  z-index: 100;
  width: 100%;
  background-color: #fff;
  max-height: 100vh;
  overflow-y: scroll;
  .chacha {
    color: #000;
    position: absolute;
    right: 2vw;
    top: 0;
    z-index: 101;
    font-size: 28px;
  }
  .container h1 {
    color: #000;
  }
  .list-group {
    margin-left: -40px;
    overflow: hidden;
    font-size: 0;
    .ul {
      width: 24.3333%;
      vertical-align: top;
      display: inline-block;
      font-size: 14px;
    }
    li {
      margin-top: 40px;
      margin-left: 40px;
      line-height: 2.2em;
      display: inline-block;
      .pic {
        display: inline-block;
        position: relative;
        img {
          max-width: 300px;
          width: 100%;
        }
        .hover-img {
          position: absolute;
          left: 0;
          bottom: 0;
          opacity: 0;
          transition: 0.3s;
        }
        &:hover {
          img {
            visibility: hidden;
          }
          .hover-img {
            opacity: 1;
            visibility: visible;
          }
        }
      }
      .name a {
        font-size: 30px;
        font-weight: bold;
        color: #000;
        margin-top: 10px;
        font-weight: 700;
        &:hover {
          color: #bb162b;
        }
      }
      .price {
        margin-top: 6px;
        font-size: 18px;
        span {
          font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
          font-weight: bold;
          font-size: 16px;
          color: #000;
        }
        strong {
          color: #000;
        }
        small {
          font-size: 12px;
          color: #000;
        }
      }
      .link-box {
        margin-top: 6px;
        font-weight: 700;
        a {
          display: inline-block;
          color: #000;
          &:hover {
            color: #bb162b;
          }
        }
        i {
          margin-left: 8px;
        }
        a:first-child {
          margin-right: 20px;
        }
      }
      .remark {
        margin-top: 6px;
        color: #00894e;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
      }
    }
    @media (max-width: 767px) {
      .ul {
        width: 50%;
      }
    }
    @media (max-width: 767px) {
      li {
        .name a {
          font-size: 20px;
        }
        .link-box {
          font-size: 12px;
          i {
            margin-left: 4px;
          }
          a:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }
  @media (max-width: 767px) {
    top: 0px;
    .chacha {
      color: #fff;
      position: absolute;
      right: 6px;
      top: 0;
      z-index: 101;
      font-size: 18px;
    }
  }
  &.vehicle-list-hover {
    pointer-events: all;
    opacity: 1;
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    transform: translate(0, 0);
  }

  .vehicle-list {
    .container {
      text-align: left;
    }
  }
}
</style>
